import type { IFsVariable, IFsVariableData } from "@/shared/types";
import { api } from "./api";

export const fastVersioningApi = api.injectEndpoints({
  endpoints: (builder) => ({
    getFastVars: builder.query({
      query: () => "/fast-version",
      providesTags: ["fs-variables"],
    }),
    createFastVar: builder.mutation<
      IFsVariable,
      {
        variableData: Partial<IFsVariableData>;
        orgId: string;
      }
    >({
      query: ({ variableData, orgId }) => ({
        url: "/fast-version",
        method: "POST",
        body: { variable: variableData, orgId },
      }),
      invalidatesTags: ["fs-variables"],
    }),
    updateFastVar: builder.mutation<
      IFsVariable,
      {
        id: string;
        data: Partial<IFsVariable>;
      }
    >({
      query: ({ id, data }) => ({
        url: `/fast-version/${id}`,
        method: "POST",
        body: { ...data },
      }),
      invalidatesTags: ["fs-variables"],
    }),
    deleteFastVar: builder.mutation<
      {
        acknowledged: boolean;
        deletedCount: number;
      },
      {
        id: string;
      }
    >({
      query: ({ id }) => ({
        url: `/fast-version/${id}`,
        method: "DELETE",
      }),
      invalidatesTags: ["fs-variables"],
    }),
  }),
});

export const {
  useGetFastVarsQuery,
  useLazyGetFastVarsQuery,
  useUpdateFastVarMutation,
  useDeleteFastVarMutation,
  useCreateFastVarMutation,
} = fastVersioningApi;
